import React, { useEffect } from 'react';
import { Outlet } from 'react-router';

import { store } from '../reducers';
import { changeCurrentOrganization } from '../reducers/organization/reducer';

import { useQuery } from '@tanstack/react-query';
import { organizationsQueryOptions } from '../queryOptions';

import {
  AppHeader,
  LoadingSpinner,
  VStack,
} from '@adc/parallax-component-library';
import { BreadcrumbNav } from '../components/breadcrumbNav/BreadcrumbNav';
import UserMenu from '../components/userMenu/UserMenu';
import SideNav from '../components/sideNav/SideNav';
import { getSessionObject } from '../utilities/storage';
import NoOrganizations from '../components/utility/NoOrganizations';

/**
 * The main layout component that wraps the application with a header and footer
 * @returns {React.JSX.Element}
 */
export default function MainLayout() {
  const organizations = useQuery(organizationsQueryOptions());

  useEffect(() => {
    if (organizations.isSuccess) {
      let currentOrganization = getSessionObject('currentOrganization');

      if (
        organizations.data.length &&
        (!currentOrganization ||
          !organizations.data.find((org) => org.key === currentOrganization))
      ) {
        currentOrganization = organizations.data[0].key;
      }

      store.dispatch(changeCurrentOrganization(currentOrganization));
    }
  }, [organizations.data, organizations.isSuccess]);

  return (
    <>
      <div className="sticky-header">
        <AppHeader
          title="ClinicalView"
          buttons={[<UserMenu key="user-menu" />]}
        />
      </div>
      <div className="main-content">
        <SideNav />
        <main>
          {organizations.isPending ? <VStack /> : <BreadcrumbNav />}

          {organizations.isPending ? (
            <VStack
              alignItems="center"
              justifyContent="center"
              flexGrow={1}
              height="100%"
              width="100%"
            >
              <LoadingSpinner testID="main-layout-loading-spinner" />
            </VStack>
          ) : (
            <div className="page-content">
              {organizations.isError || organizations.data.length === 0 ? (
                <NoOrganizations />
              ) : (
                <Outlet />
              )}
            </div>
          )}
        </main>
      </div>
    </>
  );
}
